import { oc } from '@orpc/contract';
import { listValuationsInputSchema, listValuationsOutputSchema } from '../schemas/valuations.schemas.js';
/** Newest first, with the versions each was computed with and whether the record has moved on since. */
export const listValuationsContract = oc
    .route({
    method: 'GET',
    path: '/valuations',
    tags: ['Valuations'],
    summary: 'List the saved snapshots of an estimate or a stock vehicle',
})
    .input(listValuationsInputSchema)
    .output(listValuationsOutputSchema);
//# sourceMappingURL=list-valuations.contract.js.map